import { store as globalStore } from '$lib/utilities/store';
import { get } from 'svelte/store';

import collectionPermissions from '$lib/data/generated/collections.json';

export const removeListeners = () => {
	console.log('removing listeners for logout');
	const store = get(globalStore);

	(store?.userProfileListener || (() => { }))();
	delete store.userProfileListener;
	(store?.userRolesListener || (() => { }))();
	delete store.userRolesListener;

	const roles = store?.userRoles || {};

	const collections = Object.entries(collectionPermissions)
		.filter(([k, v]) => Object.keys(roles)
			.filter(k => roles[k])
			.concat('public')
			.filter(r => (v.read || []).includes(r))
			.length > 0)
		.map(([k, _]) => k.split('/').filter(e => !!e))
		.filter(e => e.length === 1)
		.map(e => e.at(0))
		.sort();

	for (const alias of collections) {
		console.log(`removing ${alias} listener`);
		typeof store?.[`${alias}Listener`] === 'function' && store?.[`${alias}Listener`]();
		delete store[alias];
		delete store[`${alias}Listener`];
	}
	delete store.userProfile;
	delete store.userRoles;

	globalStore.set({ ...store });
};
